const API_ENDPOINTS = {
    BASE_URL: "https://api.themoviedb.org/3",
    TRENDING: "/trending/all/week",
    AIRING_TODAY: "/tv/airing_today",
    ON_THE_AIR: "/tv/on_the_air",
    POPULAR: "/tv/popular",
    TOP_RATED: "/tv/top_rated",
  };
  
  export default API_ENDPOINTS;